// extracted by mini-css-extract-plugin
export default {"buttonComponent":"Button_buttonComponent__uIXB2"};